export const companyProfileEndpoints = { base: "/api/company/profile" } as const;
